/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProviderCertificationList } from '../models/PaginatedProviderCertificationList';
import type { PatchedProviderCertificationWrite } from '../models/PatchedProviderCertificationWrite';
import type { ProviderCertification } from '../models/ProviderCertification';
import type { ProviderCertificationWrite } from '../models/ProviderCertificationWrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderCertificationsService {

    /**
     * @returns PaginatedProviderCertificationList
     * @throws ApiError
     */
    public static providerCertificationsList({
        limit,
        offset,
        provider,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        provider?: string,
    }): CancelablePromise<PaginatedProviderCertificationList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-certifications/',
            query: {
                'limit': limit,
                'offset': offset,
                'provider': provider,
            },
        });
    }

    /**
     * @returns ProviderCertification
     * @throws ApiError
     */
    public static providerCertificationsCreate({
        requestBody,
    }: {
        requestBody: ProviderCertificationWrite,
    }): CancelablePromise<ProviderCertification> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-certifications/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCertification
     * @throws ApiError
     */
    public static providerCertificationsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this certification.
         */
        id: string,
    }): CancelablePromise<ProviderCertification> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-certifications/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderCertification
     * @throws ApiError
     */
    public static providerCertificationsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this certification.
         */
        id: string,
        requestBody?: PatchedProviderCertificationWrite,
    }): CancelablePromise<ProviderCertification> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-certifications/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static providerCertificationsDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this certification.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/provider-certifications/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
